module.exports = __webpack_public_path__ + "b70fc5ea.svg";